import { render, staticRenderFns } from "./AdminCreditRequestList.vue?vue&type=template&id=436a84c8"
import script from "./AdminCreditRequestList.vue?vue&type=script&lang=js"
export * from "./AdminCreditRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports